import styled, { css } from 'styled-components';
import {
  Title as DefaultTitle,
  Modal as DefaultModal,
} from '@getinapp/appetizer';

export const Modal = styled(DefaultModal)`
  background: white;

  > button > span {
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }
`;

export const Paragraph = styled.p<{ isVariant?: boolean }>`
  ${({ theme, isVariant }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
    margin-bottom: 1rem;

    ${isVariant &&
    css`
      color: ${theme.colors.primary};
      margin-bottom: 1.5rem;
      cursor: pointer;
    `}
  `}
`;

export const Title = styled(DefaultTitle)`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large} !important;
  `}
`;

export const LineBreak = styled.div`
  margin-bottom: 1.5rem;
`;

export const BackButton = styled.p`
  margin-top: 1.5rem;

  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;

    &:hover {
      cursor: pointer;
    }
    span {
      margin-right: 1rem;
    }
  `}
`;
